import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Box, Button, Divider, IconButton, TextField, useMediaQuery } from '@mui/material'
import styles from "../Chat/chat.module.scss"
import { AttachmentIcon } from '../../assets/icons/attachment-icon'
import { SendIcon } from '../../assets/icons/send-icon'
import UserCard from '../Chat/UserCard/UserCard'
import SenderMessageCard from '../Chat/SenderMessageCard/SenderMessageCard'
import OwnMessageCard from '../Chat/OwnMessageCard/OwnMessageCard'
import FilesCard from '../Chat/FIlesCard/FilesCard'
import Textarea from '../common/Textarea/Textarea'
import ButtonFilled from '../common/Button/ButtonFilled'
import { ArrowBack } from '@mui/icons-material'
import useWindowDimensions from '../../hooks/useWindowDimensions'

let usersList = ["Abid Ullah", "Muhammad Farhan", "Faizan Ahmed", "Lana Steiner", "Demi Wilkinson", "Demi Wilkinson", "Demi Wilkinson", "Demi Wilkinson", "Demi Wilkinson", "Demi Wilkinson"]
function SmallScreen() {

    const isMobile = useMediaQuery('(max-width:670px)');
    const [back, setBack] = useState(false);
    const handleClose = useCallback(() => {
        setBack(!back);
    }, []);
    const { width } = useWindowDimensions();
    useEffect(() => {
        if (width > 720) {
            !back && setBack(true);
        } else {
            back && setBack(false);
        }
    }, [width])
    const fileInputRef = useRef(null);
    // 03112487204
    const handleButtonClick = () => {
        console.log("click")
        fileInputRef.current.click();
    };
    const handleFileChange = (e) => {
        console.log(e.target.value);
        // Handle the selected file here
    };
    return (
        <div>
            {isMobile && back && <div onClick={() => {
                setBack(false)
            }}
            >
                <ArrowBack style={{ paddingTop: '20px', cursor: 'pointer' }} />
            </div>}
            <Box className={styles.container}>

                {isMobile && !back ? <Box style={{ width: back ? ' 208px' : "100%" }} className={styles.side_bar}>
                    <div className={styles.top_heading_container}>
                        <div className={styles.heading}>
                            Chat Name
                        </div>
                        <div className={styles.sub_heading}>
                            10 users
                        </div>
                    </div>
                    <Divider color='red' component="div" />
                    <div className={styles.users_list_container}>
                        {usersList?.map(user =>
                            <UserCard title={user} callback={handleClose} />
                        )}
                    </div>
                </Box>
                    :
                    <Box style={{ width: !back ? ' calc(100% - 210px)' : "100%" }} className={styles.main_container}>
                        <div className={styles.message_top}>
                            <div className={styles.messages_title}> Messages </div>
                            <Divider color='red' component="div" />
                            <div className={styles.messages_container}>
                                <SenderMessageCard messageInfo={""} />
                                <OwnMessageCard messageInfo={""} />
                                <SenderMessageCard messageInfo={""} containFile={true} />
                                <OwnMessageCard messageInfo={""} containFile={true} />

                            </div>
                        </div>
                        <Divider component="div" />

                        <div className={styles.message_footer}>
                            <div className={styles.typing_and_container}>
                                <div className={styles.attachment} onClick={handleButtonClick}>
                                    <AttachmentIcon />
                                </div>
                                <div className={styles.message_input}>
                                    <Textarea />
                                    <div className={styles.files_container}>
                                        <FilesCard title="Tech design requirements.pdf" size="200KB" status="Pending" />
                                        <FilesCard title="Tech design requirements.pdf" size="200KB" status="Done" />
                                        <FilesCard title="Tech design requirements.pdf" size="200KB" status="error" />
                                    </div>
                                    <div className={styles.choose_container}>
                                        <input
                                            type="file"
                                            id="file-upload"
                                            style={{ display: 'none' }}
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                        />


                                        <ButtonFilled onClick={handleButtonClick} htmlFor="file-upload" text="Choose file..." backgroundColor='#FFF' color='#344054' border="none" />
                                    </div>
                                </div>
                                <div className={styles.send_btn}>
                                    <ButtonFilled icon={<SendIcon />}  />

                                </div>
                            </div>

                            <div className={styles.upload_container}>
                                <ButtonFilled text="Upload" backgroundColor='#EDF6FD' color='#0083DC' />
                                <ButtonFilled text="All cancel" backgroundColor='#EDF6FD' color='#0083DC' border="none" />

                            </div>
                        </div>
                    </Box>}
            </Box>
        </div >
    )
}

export default SmallScreen